<div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
  <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Search</h2>
  <form [formGroup]="filterForm" (ngSubmit)="Search()" class="w-full flex flex-wrap">
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">From Date</b>
      <p-calendar formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
        class="w-full" styleClass="cal_full" />
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">To Date</b>
      <p-calendar formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
        class="w-full" styleClass="cal_full" />
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Mentor Name</b>
      <p-autoComplete formControlName= "name" [suggestions]="names"
        [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('name')?.value}"
        class="w-full" (completeMethod)="filterNames($event)" styleClass="fullWidth" optionValue="name"
        optionLabel="name">
      </p-autoComplete>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Company</b>
      <p-autoComplete formControlName= "companyOrSchool" [suggestions]="places"
        [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('companyOrSchool')?.value}"
        class="w-full" (completeMethod)="filterPlaces($event)" styleClass="fullWidth" optionValue="name"
        optionLabel="name">
      </p-autoComplete>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Work Experience(Years/Months)</b>
      <div class="w-full flex gap-1 align-items-start sm:flex-row flex-column" formGroupName="totalExperience">
        <div class="w-full flex flex-column gap-2 flex-1">
          <!-- <b class="text-left font-normal text-base">Years</b> -->
          <p-dropdown [options]="years" formControlName="years"
            [ngClass]="{'ng-invalid ng-dirty' : submitted && ! filterForm.get('totalExperience.years')?.value}"
            optionLabel="name" placeholder="Year" styleClass="selectBox1" appendTo="body" class="w-full" />
        </div>
        <div class="w-full flex flex-column gap-2 flex-1">
          <!-- <b class="text-left font-normal text-base">Months</b> -->
          <p-dropdown [options]="months" formControlName="months"
            [ngClass]="{'ng-invalid ng-dirty' : submitted && ! filterForm.get('totalExperience.months')?.value}"
            optionLabel="name" placeholder="Month" styleClass="selectBox1" appendTo="body" class="w-full" />
        </div>
      </div>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Nationality</b>
      <p-dropdown [options]="countries" styleClass="selectFull" class="w-full" optionLabel="name"
        optionValue="name" formControlName="nationality" [filter]="true" filterBy="name" [showClear]="true"
        appendTo="body" placeholder="Select a Country">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ country.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
      <b class="text-left font-normal text-base" style="color: #424242;">Email Address</b>
      <input type="text" formControlName="email" pInputText class="w-full" />
      <small *ngIf="filterForm.get('email')?.invalid" class="ng-dirty ng-invalid text-red-500">Enter valid email</small>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2" *ngIf="!isOperations">
      <b class="text-left font-normal text-base" style="color: #424242;">Status</b>
      <p-dropdown [options]="statuses" styleClass="selectFull" class="w-full" optionLabel="name"
        optionValue="value" formControlName="status" filterBy="name" [showClear]="true"
        appendTo="body" placeholder="Select Admin-State">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ option.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column justify-content-end">
      <p-button label="Search" [loading]="isSearching" [disabled]="filterForm.invalid" class="w-full"
        styleClass="buttonFull" type="submit" (onClick)="Search()" />
    </div>
  </form>
</div>
